import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _get from 'lodash.get';
import Link from 'components/Link';
import ImageV2 from 'components_v2/common/ImageV2';
import s from './ButtonPreferredSources.scss';
import {
  IMAGE_URL_PREFERRED_SOURCES_BASE,
  IMAGE_URL_PREFERRED_SOURCES_WEB_WIDTH,
  IMAGE_URL_PREFERRED_SOURCES_MOBILE_WIDTH,
} from '../../../constants';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';

const ButtonPreferredSources = props => {
  const {
    label,
    isFloatingButton,
    ariaLabel,
    scrollThreshold = 330,
    msid,
    linkUrl,
    title,
    gaType,
    isTOIReviews,
    isWapView,
    //isSportsSection,
    isBusinessSection,
    isCityPage,
    cityMsid,
    //isTechnologySection,
  } = props;

  const [isVisible, setIsVisible] = useState(false);

  useEffect(
    () => {
      if (!isFloatingButton) return;

      const handleScroll = () => {
        const scrollY = window.scrollY || window.pageYOffset;
        setIsVisible(scrollY > scrollThreshold);
      };

      // Add safety check for window availability
      if (typeof window !== 'undefined' && window.addEventListener) {
        // Add scroll event listener
        window.addEventListener('scroll', handleScroll);

        // Initial check
        handleScroll();

        // Cleanup
        // eslint-disable-next-line consistent-return
        return () => window.removeEventListener('scroll', handleScroll);
      }
    },
    [isFloatingButton, scrollThreshold],
  );

  const handleClick = (cityGaType, cityGaLabel) => {
    const typeval = 'preferred_source';
    // if (isFloatingButton) {
    //   typeval = 'TOI Habit Index';
    // }
    // GA Event tracking
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: gaType || typeval,
      label: label || 'N/A',
    });
  };

  // Nudge URL
  let linkNudgeUrl = `https://timesofindia.indiatimes.com/preferences.cms?src=${
    isFloatingButton ? 'floating' : 'nudge'
  }`;

  // Select image URL based on platform and use case
  const regularImageMsid = '123518384';

  let floatingImageMsid = msid || '123540711';

  if (isBusinessSection) {
    linkNudgeUrl =
      'https://timesofindia.indiatimes.com/toi/ecopreneur-awards?ag=floating&utm_source=business-Ecopreneur&utm_medium=Article&utm_campaign=Promotion&utm_content=NominateNow&utm_term=Ecopreneur2026';
  }

  if (isTOIReviews) {
    linkNudgeUrl = `https://www.google.com/preferences/source?q=toireviews`;
  }
  if (isBusinessSection) {
    floatingImageMsid = '129630514';
  }
  // Build dynamic URLs for regular (non-floating) button
  const imageUrl = isWapView
    ? `${IMAGE_URL_PREFERRED_SOURCES_BASE}${regularImageMsid}${IMAGE_URL_PREFERRED_SOURCES_MOBILE_WIDTH}${regularImageMsid}.jpg`
    : `${IMAGE_URL_PREFERRED_SOURCES_BASE}${regularImageMsid}${IMAGE_URL_PREFERRED_SOURCES_WEB_WIDTH}${regularImageMsid}.jpg`;

  // Build dynamic URLs for floating button
  const floatingImageUrl = isWapView
    ? `${IMAGE_URL_PREFERRED_SOURCES_BASE}${floatingImageMsid}${IMAGE_URL_PREFERRED_SOURCES_MOBILE_WIDTH}${floatingImageMsid}.jpg`
    : `${IMAGE_URL_PREFERRED_SOURCES_BASE}${floatingImageMsid}${IMAGE_URL_PREFERRED_SOURCES_WEB_WIDTH}${floatingImageMsid}.jpg`;

  return (
    <div
      className={`
      ${s.buttonPreferredSources}
      ${isFloatingButton ? s.floatingButton : ''}
      ${isFloatingButton && isVisible ? s.visible : ''}
    `}
    >
      <Link
        to={linkUrl || linkNudgeUrl}
        target="_blank"
        onClick={() => handleClick()}
        doNotChangeURL
        doNotChangeDomain
        ariaLabel={ariaLabel}
      >
        {isFloatingButton ? (
          <ImageV2
            src={floatingImageUrl}
            alt={title || 'Preferred Sources Button'}
            aria-label={title || 'Preferred Sources Button'}
          />
        ) : (
          <ImageV2
            src={imageUrl}
            alt={title || 'Preferred Sources Button'}
            aria-label={title || 'Preferred Sources Button'}
          />
        )}
      </Link>
    </div>
  );
};

ButtonPreferredSources.propTypes = {
  label: PropTypes.string,
  isFloatingButton: PropTypes.bool,
  isWapView: PropTypes.bool,
  //isSportsSection: PropTypes.bool,
  isBusinessSection: PropTypes.bool,
  ariaLabel: PropTypes.string,
  scrollThreshold: PropTypes.number,
  //msid: PropTypes.string,
  linkUrl: PropTypes.string,
  title: PropTypes.string,
  gaType: PropTypes.string,
  //isTechnologySection: PropTypes.bool,
};

ButtonPreferredSources.defaultProps = {
  label: 'N/A',
  isFloatingButton: false,
  isWapView: false,
  ariaLabel: '',
  scrollThreshold: 330,
  //msid: '',
  linkUrl: '',
  title: '',
  gaType: '',
  //isSportsSection: false,
  isBusinessSection: false,
  // isTechnologySection: false,
};

const mapStateToProps = state => ({
  isWapView: _get(state, 'isMobile', false),
  isTOIReviews: _get(state, 'isTOIReviews', false),
});

export default connect(mapStateToProps)(ButtonPreferredSources);
